import { calculateBMI, adjustETTSizeForBMI } from './bmiUtils';

export interface ETTCalculations {
  idealCalculations: {
    cole: number;
    motoyama: number | null;
    khine: number | null;
    duracher: number | null;
    heightBased: number | null;
    weightBased: number | null;
  };
  adjustedCalculations: {
    cole: number;
    motoyama: number | null;
    khine: number | null;
    duracher: number | null;
    heightBased: number | null;
    weightBased: number | null;
  };
  bmi: number | null;
  bmiCategory: string;
}

export interface InsertionDepths {
  basic: number;
  oral: number;
  nasal: number;
  heightBased1: number;
  heightBased2: number;
}

export const calculateETTSizes = (ageInYears: number, height: number | null, weight: number | null) => {
  // Default age to 0 if less than 1 year
  const effectiveAge = ageInYears < 1 ? 0 : ageInYears;
  
  const idealCalculations = {
    cole: effectiveAge === 0 ? 3.5 : effectiveAge / 4 + 4,
    motoyama: effectiveAge >= 2 ? effectiveAge / 4 + 3 : 3,
    khine: effectiveAge === 0 ? 3 : effectiveAge / 4 + 3,
    duracher: effectiveAge === 0 ? 3.5 : effectiveAge / 4 + 3.5,
    heightBased: height ? 4 + 0.1 * height : null,
    weightBased: weight ? weight / 10 + 3.5 : null
  };

  const { bmi, category } = calculateBMI(height, weight);

  const adjustedCalculations = {
    cole: adjustETTSizeForBMI(idealCalculations.cole, category),
    motoyama: adjustETTSizeForBMI(idealCalculations.motoyama, category),
    khine: adjustETTSizeForBMI(idealCalculations.khine, category),
    duracher: adjustETTSizeForBMI(idealCalculations.duracher, category),
    heightBased: idealCalculations.heightBased ? adjustETTSizeForBMI(idealCalculations.heightBased, category) : null,
    weightBased: idealCalculations.weightBased ? adjustETTSizeForBMI(idealCalculations.weightBased, category) : null
  };

  return {
    idealCalculations,
    adjustedCalculations,
    bmi,
    bmiCategory: category
  };
};

export function calculateInsertionDepths(height: number | null): InsertionDepths | null {
  if (!height) return null;
  return {
    basic: (height / 8) + 3.4,
    oral: (height / 10) - 3,
    nasal: (height / 10) + 1,
    heightBased1: 4 + (0.1 * height),
    heightBased2: 3 + (0.1 * height)
  };
} 